export const getWebhookMutationKey = () => [`planner_webhook`];
